import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

const CheckTones = {
  redline: 'text-redline',
  steel: 'text-steel',
};

export function CheckList({ items, tone = 'redline', className }) {
  return (
    <ul className={cn('space-y-3', className)}>
      {items.map((item) => (
        <li key={item} className="flex gap-3 leading-snug text-graphite">
          <Check aria-hidden="true" strokeWidth={3} className={cn('mt-0.5 size-4 shrink-0', CheckTones[tone])} />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}